'use strict';

var $    = require('jquery');
var _    = require('underscore');
var Core = require('../core/core.js');

/**
 * Creates an inspector with selectbox
 *
 * @class
 */

class InspectorSelectboxCustomOption extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
        'selectbox': {},
        'custombox': {},
        'option': {}
      }
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<li class="editor__inspector__item__select__custom__option">
        <div class="js-inspector__select__option" data-value="<%- option.value %>">
          <%- option.name %>
        </div>
      </li>
		`;

		super.render();

		this.val = options.fields.option.value;

    this.$el.hover(this._selectOption);

    $(".js-inspector__select__option", this.$el).on('click', function(e) {
      options.fields.selectbox.val(options.fields.option.value);
      options.fields.selectbox.trigger('change');
      options.fields.custombox.setValue(options.fields.option.name, options.fields.option.value);
      options.fields.custombox.hide();
    });
	}

  _selectOption(e) {
    $(e.currentTarget).siblings()
      .removeClass('editor__inspector__item__select__custom__option-hover');
    $(e.currentTarget)
      .addClass('editor__inspector__item__select__custom__option-hover');
  }

  selectOption() {
    this.$el.addClass('editor__inspector__item__select__custom__option-hover');
  }

	deselectOption() {
		this.$el.removeClass('editor__inspector__item__select__custom__option-hover');
	}

}
module.exports = InspectorSelectboxCustomOption;
